<template>
  <div wrap class="pa-3">
    <div class="text-center">
      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-for="(w) in availableWaivers">
          <v-btn class="mr-1" elevation="0" v-if="w.active == null || w.active" @click="swicthWaiverLang(w.lang)"
            :color="w.lang == selectedLang ? 'pink' : 'primary'" fab small dark :key="w.lang">
            {{ w.lang }}
          </v-btn>
        </template>
      </v-card-actions>
    </div>
    <div class="text-h6" style="margin-bottom:10px">
      {{ $d(today, 'short', selectedLang) }}
    </div>
    <v-card elevation="0" class="mb-2" outlined>
      <v-card-text class="mt-2" v-html="waiverContents"></v-card-text>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field dense outlined :label="$t('message.first_and_last_name', selectedLang)"
              :rules="[rules.validName]" v-model="participantName"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field dense outlined :label="$t('message.email', selectedLang)" v-model="participantEmail"
              :rules="emailRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field dense outlined :label="$t('message.guardian', selectedLang)"
              v-model="guardianName"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field dense outlined :label="$t('message.phone', selectedLang)" v-model="phone"></v-text-field>
          </v-col>
        </v-row>
        <div class="supporting-text">
          {{ $t('message.todays_date') }}
        </div>
        <v-row class="mb-1">
          <v-col>
            <div>
              <v-icon size="35" v-if="notToday" color="error">mdi-calendar-remove-outline</v-icon>
              <DatePicker v-model="todaysDate">
              </DatePicker>
            </div>
          </v-col>
        </v-row>
        <div v-if="extraFieldValues && extraFieldValues.length > 0">
          <v-list>
            <template v-for="(field, index) in extraFieldValues">
              <v-text-field dense outlined :key="'extra_field_' + index"
                :label="field.fieldName + (field.required ? ' (' + $t('message.required').toLowerCase() + ')' : '')"
                v-model="field.value"></v-text-field>
            </template>
          </v-list>
        </div>
        <div v-if="messages" class="messages-area text-center" v-html="messages" style="padding:5px"></div>
        <div class="text-center">
          <div class="text-small">
            {{ $t('message.signature_student_guardian', [selectedLang]) }}
          </div>
          <Vue-Signature style="border: 1px solid black; margin-left:auto; margin-right:auto;" :w="'100%'" :h="'150px'"
            ref="waiverSignature" :sigOption="signatureOptions"></Vue-Signature>
        </div>
      </v-card-text>
      <v-card-actions class="pt-4">
        <v-btn block large depressed :disabled="!participantName || !participantEmail || submitting" color="primary"
          @click="submitWaver()">
          <v-progress-circular v-if="submitting" indeterminate color="white"></v-progress-circular>
          {{ $t('message.accept', [selectedLang]) }}
        </v-btn>
      </v-card-actions>
      <v-card-actions class="pt-4">
        <v-spacer></v-spacer>
        <v-btn depressed small elevation="0" outlined color="secondary" @click="clearSignature()">{{
          $t('message.clear_signature') }}</v-btn>
        <v-btn small depressed color="secondary" @click="cancelWaiver()">{{ $t('message.cancel', selectedLang)
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <div style="height: 40px">

    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import Api from "@/services/Api";
import VueSignature from "vue-signature";

export default {
  name: "Waiver",
  data() {
    return {
      loading: false,
      scheduleClassId: this.$route.query.scid,
      academyClassId: this.$route.query.acid,
      messages: null,
      participantName: null,
      participantEmail: null,
      guardianName: null,
      phone: null,
      todaysDate: new Date(),
      extraFieldValues: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\s)*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(\s)*$/.test(
            v
          ) || this.$t("message.invalid_email"),
      ],
      todaysDay: null,
      today: new Date(),
      signatureOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
      },
      availableWaivers: null,
      selectedLang: "en",
      notToday: false,
      waiverContents: this.$t("message.loading"),
      rules: {
      },
      submitting: false,
    };
  },
  components: {
    VueSignature,
    DatePicker
  },
  created() {
    Api()
      .get(
        "admintablet/academy/" +
        this.$store.state.tabletManagedAcademy +
        "/waivers"
      )
      .then(response => {
        this.loading = false;
        const data = response.data;
        if (data && data[0]) {
          const currentLang = this.$i18n.locale;
          const waiverLang = data[0].lang;
          if (currentLang == waiverLang) {
            this.availableWaivers = data;
            this.selectedLang = data[0].lang;
            this.waiverContents = data[0].agreement;

            this.extraFieldValues = data[0].extraFields;
          } else {
            //Swap orders
            let orderedWaivers = [];
            let currentLangWaiver = null;
            for (let w of data) {
              if (w.lang == currentLang) {
                currentLangWaiver = w;
                break;
              }
            }
            if (currentLangWaiver)
              orderedWaivers.push(currentLangWaiver);
            for (let w of data) {
              if (w.lang != currentLang)
                orderedWaivers.push(w);
            }
            this.availableWaivers = orderedWaivers;
            this.selectedLang = orderedWaivers[0].lang;
            this.waiverContents = orderedWaivers[0].agreement;
            this.extraFieldValues = orderedWaivers[0].extraFields;
          }
        }
      });
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy)
      .then(response => {
        const data = response.data;
        if (data) {
          if (!data.active) {
            this.navigateTo({ name: 'inactiveaccount' });
            return;
          }
        }
      });
    const vm = this;
    this.rules.validName = function (value) {
      let validName = /^[a-zA-Z0-9]+(\s)+[a-zA-Z0-9]+(\s)*[a-zA-Z0-9]*/.test(value);
      if (validName) {
        return true;
      }
      return vm.$t("message.provide_correct_name", vm.selectedLang)
    }
  },
  methods: {
    cancelWaiver() {
      this.navigateTo({ name: "checkin" });
    },
    swicthWaiverLang(newLang) {
      if (newLang != this.selectedLang) {
        this.selectedLang = newLang;
        for (const w of this.availableWaivers) {
          if (w.lang == newLang && w.agreement) {
            this.waiverContents = w.agreement;
          }
        }
      }
    },
    isToday() {
      try {
        const d1 = new Date();
        const d2 = this.todaysDate ? this.todaysDate : new Date();

        const isToday = d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate();
        if (!isToday)
          this.notToday = true;
        return isToday;
      } catch (e) {
        this.notToday = true;
        return false;
      }
    },
    clearSignature() {
      var _this = this;
      _this.$refs.waiverSignature.clear();
    },
    canSubmit() {
      let canSubmit = this.participantName && this.todaysDate;
      if (this.participantName) {
        const validName = this.rules.validName(this.participantName);
        return validName
      }
      if (!this.isValidEmail(this.participantEmail)) {
        return false;
      }
      return canSubmit;
    },
    submitWaver() {
      this.notToday = false;
      //Add succeess message and close one second after
      let _this = this;
      if (!this.canSubmit()) {
        this.messages =
          '<span style="color:red;font-size:1.5em">' +
          this.$t("message.provide_correct_name", this.selectedLang) +
          "</span>";
        return;
      }
      if (!this.isValidEmail(this.participantEmail)) {
        this.messages =
          '<span style="color:red;font-size:1.5em">' +
          this.$t("message.invalid_email") +
          "</span>";
        return;
      }
      let pngImage = _this.$refs.waiverSignature.save();
      if (_this.$refs.waiverSignature.isEmpty()) {
        this.messages =
          '<span style="color:red;font-size:1.5em">' +
          this.$t("message.please_sign", this.selectedLang) +
          "</span>";
        return;
      }
      if (this.extraFieldValues && this.extraFieldValues.length > 0) {
        for (const field of this.extraFieldValues) {
          if (field.required && !field.value) {
            this.messages = '<span style="color:red;font-size:1.5em">' + this.$t('message.complete_required_parameters') + '</span>';
            return;
          }
        }
      }
      if (this.isToday()) {
        this.submitting = true;
        //Post data
        const date = new Date();
        const postData = {
          name: this.participantName,
          guardianName: this.guardianName,
          phone: this.phone,
          email: this.participantEmail.trim().toLowerCase(),
          userDate: this.todaysDate,
          initials: this.initials,
          lang: this.selectedLang,
          day: this.getDayString(date),
          contents: this.waiverContents,
          extraFieldValues: this.extraFieldValues,
          scheduleClassId: this.scheduleClassId,
          academyClassId: this.academyClassId,
          signature: pngImage
        };
        Api()
          .post(
            "admintablet/academy/" +
            this.$store.state.tabletManagedAcademy +
            "/waiver",
            postData
          )
          .then(response => {
            const data = response.data;
            if (data) {
              const vm = this;
              try {
                this.messages =
                  '<span style="color:green;font-size:1.5em">' +
                  this.$t("message.doc_submitted", this.selectedLang) +
                  "</span>";
                setTimeout(function () {
                  vm.cancelWaiver();
                }, 1000);
              } catch (e) {
                console.log(e);
                this.submitting = false;
              }
            }
          })
          .catch(e => {
            this.submitting = false;
            if (e)
              this.messages =
                '<span style="color:red;font-size:1.5em">Error</span>';
          });
      } else {
        //Show Message
        this.messages =
          '<span style="color:red;font-size:1.5em">' +
          this.$t("message.confirm_today", this.selectedLang) +
          "</span>";
      }
    },
    allowSubmit() {
      return true;
    }
  }
};
</script>
<style scoped>
@media only screen and (max-width: 541px) {
  .available-text {
    font-size: 0.775em;
  }
}

@media only screen and (min-width: 542px) {
  .v-dialog {
    width: 50% !important;
  }
}
</style>
